'use client';

import type { ReactNode } from 'react';
import { ConfirmEmailAlert } from '@/components/ConfirmEmailAlert';
import { GameSelectionNavigation } from '@/components/GameSelectionNavigation';

const PickemsLayout = ({ children }: { children: ReactNode }) => {
  return (
    <>
      <GameSelectionNavigation />
      <ConfirmEmailAlert />
      {children}
    </>
  );
};

export default PickemsLayout;
